import React, {Component} from "react"
import Select from 'react-select';
import {withTranslate} from "react-redux-multilingual"
import {getOfferCategoriesList, setOfferCategory} from "../../store/actions/offerActions";
import {getSpecialtiesList} from "../../store/actions/specialtyActions";
import {connect} from "react-redux";
import globalMiddleware from "../../hocs/globalMiddleware";

class OfferSearch extends Component {

    state = {
        speciality: null,
        offerCategory: null,
        type: null,
        limit: 6,
        offset: 0,
        types: [
            {
                name: this.props.translate("all"),
                flag: "all",
            },
            {
                name: this.props.translate("sponsored"),
                flag: "is_featured",
            },
            {
                name: this.props.translate("most_viewed"),
                flag: "most_viewed",
            },
        ]
    };


    componentDidMount() {
        this.props.getSpecialtiesList();
    }

    handleSpecialityOnChange = (selectedOption) => {
        this.setState({speciality: selectedOption.value, offerCategory: null}, () => {
            this.props.getOfferCategoriesList(this.state.speciality.id);
        });
    };
    handleSpecialityOnChangeMobile = (e) => {
        document.getElementById("offerCategory").selectedIndex = "0";
        this.setState({speciality: JSON.parse(e.target.value), offerCategory: null}, () => {
            this.props.getOfferCategoriesList(this.state.speciality.id);
        });
    };
    handleOfferCategoryOnChange = (selectedOption) => {
        this.setState({offerCategory: selectedOption.value});
    };
    handleOfferCategoryOnChangeMobile = (e) => {
        this.setState({offerCategory: JSON.parse(e.target.value)});
    };
    handleTypeOnChange = (selectedOption) => {
        this.setState({type: selectedOption.value});
    };
    handleTypeOnChangeMobile = (e) => {
        this.setState({type: JSON.parse(e.target.value)});
    };
    handleSearchData = async () => {
        await this.props.setOfferCategory(this.state.offerCategory ? this.state.offerCategory.id : null);
        this.props.handleSetCurrentSearchData(null, this.state.type ? this.state.type.flag : null);
    };
    clearSearchKey = async (key) => {
        let state = {
            ...this.state
        };

        switch (key) {
            case "offerCategory":
                state = {...state, offerCategory: null};
                break;
            default:
            //
        }
        switch (key) {
            case "type":
                state = {...state, type: null};
                break;
            default:
            //
        }

        await this.setState({
            ...state
        }, () => {
            this.props.handleSetCurrentSearchData("clear", null);
        });
    };

    render() {
        let offersCategories = [];
        let specialties = [];
        let offersCategoriesMobile = [];
        let specialtiesMobile = [];
        let typesList = [];
        let typesListMobile = [];

        if (this.props.offersCategories && this.props.offersCategories.length) {
            this.props.offersCategories.forEach((offerCategory) => {
                if (!this.props.mobileMenuIsShown) {
                    offersCategories = [...offersCategories, {
                        value: offerCategory,
                        label: offerCategory.name
                    }]
                } else {
                    offersCategoriesMobile = [...offersCategoriesMobile,
                        <option value={JSON.stringify(offerCategory)}>{offerCategory.name}</option>
                    ]
                }

            });
        }
        if (this.state.types && this.state.types.length) {
            this.state.types.forEach((type, index) => {
                    if (!this.props.mobileMenuIsShown) {
                        typesList = [...typesList, {
                            value: type,
                            label: type.name
                        }]
                    } else {
                        typesListMobile = [...typesListMobile,
                            <option value={JSON.stringify(type)}>{type.name}</option>
                        ]
                    }
            });
        }
        if (this.props.specialties && this.props.specialties.length) {
            this.props.specialties.forEach((specialty, index) => {
                if (specialty.categories !== 0 && specialty.offers !== 0) {
                    if (!this.props.mobileMenuIsShown) {
                        specialties = [...specialties, {
                            value: specialty,
                            label: specialty.speciality
                        }]
                    } else {
                        specialtiesMobile = [...specialtiesMobile,
                            <option value={JSON.stringify(specialty)}>{specialty.speciality}</option>
                        ]
                    }
                }
            });
        }

        return (
            <section className="main-search">
                <div className="container">
                    <div className="row shadow-4d search-box-with-shadow">
                        <div
                            className={this.props.mobileMenuIsShown ? "col-md-3 full-height no-padding border-bottom" : "col-md-3 full-height no-padding"}>
                            {!this.props.mobileMenuIsShown ?
                                <div className="form-group full-height no-padding">
                                    {/*<div className="form-label capitalized">
                                        <label>{this.props.translate("speciality")}</label>
                                    </div>*/}
                                    <div className="full-height">
                                        <i className="fa fa-stethoscope search-icon"></i>
                                        <Select hidden={this.state.isMobile}
                                                className={this.state.speciality ? "currentSearchData select-custom-styles  full-height capitalized" : "select-custom-styles  full-height capitalized"}
                                                placeholder={this.state.speciality ? this.state.speciality.speciality : this.props.translate("speciality") + "..."}
                                                onChange={this.handleSpecialityOnChange}
                                                options={specialties}
                                                value={this.state.speciality ? this.state.speciality.speciality : null}
                                        />
                                    </div>
                                </div> :
                                <select
                                    className="mobile-select custom-select capitalized"
                                    onChange={this.handleSpecialityOnChangeMobile}>
                                    <option value="" disabled
                                            selected>{this.props.translate("speciality") + "..."}</option>
                                    {specialtiesMobile}
                                </select>
                            }
                        </div>

                        <div
                            className={this.props.mobileMenuIsShown ? "col-md-3 full-height no-padding border-bottom" : "col-md-3 full-height no-padding"}>
                            {!this.props.mobileMenuIsShown ?
                                <div className="form-group full-height no-padding border-left">
                                    {/*<div className="form-label capitalized">*/}
                                    {/*<label>{this.props.translate("offer_category")}</label>*/}
                                    {/*</div>*/}
                                    <div className="full-height">
                                        <i className="fas fa-percent search-icon"></i>
                                        <Select
                                            className={this.state.offerCategory ? "currentSearchData full-height capitalized" : "full-height capitalized"}
                                            placeholder={this.state.offerCategory ? this.state.offerCategory.name : this.props.translate("offer_category") + "..."}
                                            onChange={this.handleOfferCategoryOnChange}
                                            options={offersCategories}
                                            value={this.state.offerCategory ? this.state.offerCategory.name : null}
                                        />
                                    </div>
                                </div> :
                                <select id="offerCategory"
                                        className="mobile-select custom-select capitalized"
                                        onChange={this.handleOfferCategoryOnChangeMobile}
                                >
                                    <option value="" disabled
                                            selected>{this.props.translate("offer_category") + "..."}</option>
                                    {offersCategoriesMobile}
                                </select>
                            }
                        </div>

                        <div
                            className={this.props.mobileMenuIsShown ? "col-md-3 full-height no-padding border-bottom" : "col-md-3 full-height no-padding"}>
                            {!this.props.mobileMenuIsShown ?
                                <div className="form-group full-height no-padding border-left">
                                    <div className="full-height">
                                        <i className="fas fa-layer-group search-icon"></i>
                                        <Select
                                            className={this.state.type ? "currentSearchData full-height capitalized" : "full-height capitalized"}
                                            placeholder={this.state.type ? this.state.type.name : this.props.translate("extras") + "..."}
                                            onChange={this.handleTypeOnChange}
                                            options={typesList}
                                            value={this.state.type ? this.state.type.name : null}
                                        />
                                    </div>
                                </div> :
                                <select id="offerCategory"
                                        className="mobile-select custom-select capitalized"
                                        onChange={this.handleTypeOnChangeMobile}
                                >
                                    <option value="" disabled selected>{this.props.translate("extras") + "..."}</option>
                                    {typesListMobile}
                                </select>
                            }
                        </div>
                        <div className="col-md-3  no-padding">
                            <button onClick={() => this.handleSearchData()}
                                    className="btn btn-block full-height">
                                <span className="font-20  m-r-5">{this.props.translate('search')}</span>
                            </button>
                        </div>
                    </div>
                    <div className="row mt-20">
                        <div className="col-md-12">
                            <div className="search-key">
                                <span className="block shadow-4d search-key-span"
                                      hidden={!this.state.offerCategory}>
                                {this.state.offerCategory ? this.state.offerCategory.name : ""}
                                    <i className="fas fa-times pull-right"
                                       onClick={() => this.clearSearchKey("offerCategory")}></i>
                                </span>
                                <span className="block shadow-4d search-key-span"
                                      hidden={!this.state.type}>
                                {this.state.type ? this.state.type.name : ""}
                                    <i className="fas fa-times pull-right"
                                       onClick={() => this.clearSearchKey("type")}></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        specialties: state.specialty.specialties,
        specialtyListIsLoading: state.specialty.specialtyListIsLoading,
        offersCategories: state.offer.offersCategories,
        offersCategoriesIsLoading: state.offer.offersCategoriesIsLoading,
        currentOfferCategory: state.offer.currentOfferCategory,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOfferCategoriesList: (speciality_id) => dispatch(getOfferCategoriesList(speciality_id)),
        getSpecialtiesList: () => dispatch(getSpecialtiesList()),
        setOfferCategory: (offer_category_id) => dispatch(setOfferCategory(offer_category_id)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(OfferSearch)))
